import styled from 'styled-components';

export const DarkBackground = styled.div`
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;  // Assegura que o div ocupe pelo menos a altura da tela
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
`;
